import { axiosDS } from '@pp/axios'
import { InfotecsData } from 'Pages/registratorCabinet'
import { urls } from 'Constants/Urls'
import { SimpleResponse } from 'Types/simpleResponse'

export const infotecsApi = {
	getInfotecsData: async (id: string) => {
		const res = await axiosDS().get<InfotecsData>(`${urls.customer_identification.index}/${id}`)
		return res.data
	},
	reloadInfotecsData: async (id: number) => {
		const res = await axiosDS().get<InfotecsData>(
			`${urls.customer_identification.index}/${id}/infotecs_reload_data`
		)
		return res.data
	},
	repeatIdentification: async (id: number, data: { message: string }) => {
		const res = await axiosDS().put<SimpleResponse>(
			`${urls.customer_identification.index}/${id}/rbidos_unbind`,
			{
				data,
			}
		)
		return res.data
	},
	sendToInfotecsApi: async (id: number) => {
		const res = await axiosDS().post<SimpleResponse>(
			`${urls.cabinet.rbidosCustomer}/${id}/customer_identification_document/send_to_infotecs`
		)
		return res.data
	},
	cancelIdentification: async (id: number) => {
		const res = await axiosDS().post<SimpleResponse>(
			`${urls.customer_identification.index}/${id}/reject`
		)
		return res.data
	},
	infotecsSearch: async (id: number) => {
		const res = await axiosDS().get<InfotecsData>(
			`${urls.cabinet.infotecs_search}/?rbidos_request_id=${id}`
		)
		return res.data
	},
	rbidosBind: async (id: number, rbidos_id: number) => {
		const res = await axiosDS().put<InfotecsData>(
			`${urls.cabinet.rbidosCustomer}/${id}/rbidos_bind`,
			{
				data: { rbidos_request_id: rbidos_id },
			}
		)
		return res.data
	},
}
